module.exports = __webpack_public_path__ + "static/media/orange-stories-img-002.76b3ffe6.jpg";